/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Computer_Science22Inputs */

const en__field__enum_primarystudyinterest_study_computer_science22 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Computer_Science22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer Science`)
};

const de__field__enum_primarystudyinterest_study_computer_science22 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Computer_Science22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik`)
};

/**
* | output |
* | --- |
* | "Computer Science" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Computer_Science22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_computer_science22 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Computer_Science22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Computer_Science22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_computer_science22(inputs)
	return de__field__enum_primarystudyinterest_study_computer_science22(inputs)
});
export { _field__enum_primarystudyinterest_study_computer_science22 as "_field__enum_primaryStudyInterest_STUDY_COMPUTER_SCIENCE" }